import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { CommonLabels, dataTable } from '../../models/common.model';
import { MatTableDataSource } from '@angular/material/table';

import { StorageService } from '../../services/storage.service';
import { TableService } from '../../services/table.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { commonLabels } from '../../common.labels';
import { UtilsService } from '../../services/utils.service';

@AutoUnsubscribe()
@Component({
  selector: 'table-dinamic',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnDestroy, OnChanges {
  className = 'table';
  theme = 'marketplace-default';
  labels: CommonLabels = commonLabels;
  @Input() originalData: any;
  @Input() displayedColumns;
  @Input() dataTable: dataTable[];
  @Input() isloading: boolean;
  @Input() width: number;
  @Input() noDataLabel?: string;
  @Input() view?: string;
  @Input() borderRadius?: string;
  @Input() boxShadow?: string;
  @Output() emitActionsOut = new EventEmitter();
  @Output() emitGetAllPaginator = new EventEmitter();

  show = false;
  dataSource: any;
  matSortActive: any;
  matSortDirection: any;

  constructor(
    private storageService: StorageService,
    private tableService: TableService,
    public utilService: UtilsService
  ) {}

  ngOnChanges(): void {
    if (this.width) {
      this.show = true;
      this.createTable();
    }
  }

  ngOnInit(): void {
    this.createTable();
  }

  createTable() {
    this.dataSource = null;
    this.dataSource = new MatTableDataSource(this.originalData);

    let sortBy = JSON.parse(this.storageService.retrieveListSorting(this.view));
    if (sortBy !== null) {
      this.matSortActive = sortBy.active;
      this.matSortDirection = sortBy.direction;
    }
  }

  emitActions(element, actions) {
    this.emitActionsOut.emit({ element, actions });
  }

  getAllPaginator(size?) {
    if (size === 0) {
      this.emitGetAllPaginator.emit(size);
    } else {
      this.emitGetAllPaginator.emit();
    }
  }

  storeSort(event, view?) {
    const listSort = event;
    if (listSort) {
      this.dataSource.data = this.tableService.storeSort(listSort, this.dataSource.data, view);
    } else {
      this.dataSource.data = this.tableService.storeSort(
        { active: 'online', direction: 'asc' },
        this.dataSource.data,
        view
      );
    }
  }

  ngOnDestroy(): void {}
}